import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import IconButton from 'components/common/IconButton';
import IconCross from 'components/icons/IconCross';
import IconArrowLeft from 'components/icons/IconArrowLeft';

const styles = theme => ({
  root: {
    position: 'relative',
    flexDirection: 'column',
    '& $primaryContent': {
      '& > h2': {
        opacity: '0.54',
      },
    },
  },
  rootFullScreen: {  
    '& $primaryContent': {
      padding: '0 30px',
      justifyContent: 'space-between',
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      borderBottom: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '0 8px',
      },
      '& > h2': {
        opacity: 1,
      },
    },
  },
  rootOnCloseClick: {
    '& $primaryContent': {
      position: 'relative',
      paddingRight: 50,
      paddingLeft: 50,
    },
  },
  primaryContent: {
    padding: '0 24px',
    minHeight: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  buttonClose: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
  },
  buttonBack: {
    position: 'absolute',
    top: '50%',
    left: 12,
    transform: 'translateY(-50%)',
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  iconArrowLeft: {
    width: 16,
    height: 16,
  },
});

const DialogTitle = ({
  className,
  classes,
  fullScreen,
  onCloseClick,
  onBackClick,
  children,
  secondaryContent,
  ...otherProps
}) => (
  <MuiDialogTitle
    className={classNames(classes.root, className, {
      [classes.rootFullScreen]: fullScreen,
      [classes.rootOnCloseClick]: onCloseClick,
    })}
    disableTypography
    {...otherProps}
  >
    <div className={classes.primaryContent}>
      {onBackClick &&
        <IconButton
          className={classes.buttonBack}
          onClick={onBackClick}
          tooltipContent="Go Back"
        >
          <IconArrowLeft className={classes.iconArrowLeft} />
        </IconButton>
      }
      {children}
      {onCloseClick &&
        <IconButton
          className={classes.buttonClose}
          onClick={onCloseClick}
          tooltipContent="Close Dialog"
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
      }
    </div>
    {secondaryContent &&
      <div className={classes.secondaryContent}>
        {secondaryContent}
      </div>
    }
  </MuiDialogTitle>
);

DialogTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fullScreen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onBackClick: PropTypes.func,
  secondaryContent: PropTypes.node,
  classes: PropTypes.shape({
    rootFullScreen: PropTypes.string.isRequired,
    rootOnCloseClick: PropTypes.string.isRequired,
    buttonClose: PropTypes.string.isRequired,
    buttonBack: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
    iconArrowLeft: PropTypes.string.isRequired,
  }).isRequired,
};

DialogTitle.defaultProps = {
  className: '',
  fullScreen: false,
  children: null,
  onCloseClick: null,
  onBackClick: null,
  secondaryContent: null,
};

export default withStyles(styles)(DialogTitle);



// WEBPACK FOOTER //
// ./src/components/common/Dialog/DialogTitle.js